/* eslint-disable */
import { Box, Chip, Skeleton } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { Button, Col, DatePicker, Flex, Form, Input, InputNumber, Row, Select, Spin } from 'antd';
import comptroller from 'assets/images/comptroller_white.svg';
import AntdValuePreview from 'components/dev/AntdValuePreview';
import DetailPageHeader from 'components/header/DetailPageHeader';
import InputLabel from 'components/InputLabel/index';
import MainCard from 'components/MainCard';
import { toastConfig } from 'config';
import { isEmpty } from 'lodash';
import ComptrollerConfirmModal from 'pages/comptroller/ComptrollerConfirmModal';
import { filterChildOptionLabel } from 'pages/globals/global';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { useGetQueryV3Mutation } from 'store/features/api/graphSlice';
import { useGetLynFormDataMutation } from 'store/features/comptroller/comptrollerApi';
import {
	useGetControlQuestionnaireByIdMutation,
	useGetLynFormPropertyMutation,
	useGetSingleIdentityMutation,
} from 'store/features/process/processApi';
import { disablePastDates } from 'utils/utils';

export const assurerAndControlOwnerOptions = [
	{ key: 1, label: 'Position', value: 'DATA_positionList' },
	{ key: 2, label: 'Process Role', value: 'DATA_processRoleList' },
	{ key: 3, label: 'PGR', value: 'DATA_PGRList' },
];

function Create() {
	const theme = useTheme();
	const [form] = Form.useForm();

	const { state } = useLocation();
	const navigate = useNavigate();
	const { userId, creatorOrganizationId: companyCode } = useSelector((state) => state.profile.profileData);

	const [showModal, setShowModal] = useState(false);
	const [submitData, setSubmitData] = useState();

	const [getQueryV3, { data: queryV3Data }] = useGetQueryV3Mutation();
	const [GetControlQuestionnaireById, { data: ControlQuestionnaire }] = useGetControlQuestionnaireByIdMutation();
	const [GetSingleIdentity, { error: errorData, isSuccess: isSingleCaseSuccess, isLoading: isSingleCaseLoading, isError: isSingleCaseError }] =
		useGetSingleIdentityMutation();

	const onSubmitHandler = (payload) => {
		// console.log('payload', payload);
		setSubmitData(payload);
		setShowModal(true);
	};

	const onModalOkHandler = () => {
		GetSingleIdentity({
			operation: 'add-single',
			processCode: state?.processCode,
			suffixCode: '',
			data: submitData,
		});
	};

	const onDomainFilterHandler = () => {
		const domain = form.getFieldValue('DATA_controlDomain');
		const subDomain = form.getFieldValue('DATA_controlSubDomain');
		// console.log(companyCode, domain, subDomain);
		if (companyCode && domain && subDomain) {
			// console.log(companyCode, domain, subDomain);

			const payload = {
				companyCode,
				fieldCodes: ['companyCode', 'controlDomain', 'controlSubDomain'],
				fieldValues: [companyCode, domain, subDomain],
				name: 'ControlQuestionnaireList',
			};
			getQueryV3(payload);
		}
	};

	const onSelectHandler = (controlId, obj) => {
		if (obj?.children) form.setFieldValue('controlIdLabel', obj?.children);

		const payload = {
			data: controlId,
			scriptName: 'getQuestionnaire',
			processCode: state?.processCode,
		};
		GetControlQuestionnaireById(payload);
	};

	useEffect(() => {
		if (isSingleCaseSuccess) {
			toast.success('Success! Action completed ', toastConfig);
			navigate(-1);
		}

		if (isSingleCaseError) {
			if (errorData?.data?.code === '501') {
				toast.error(errorData?.data?.message, toastConfig);
			} else {
				toast.error('Failed! Action not completed', toastConfig);
			}
		}
	}, [isSingleCaseSuccess, isSingleCaseError, errorData]);

	useEffect(() => {
		if (isEmpty(state?.processCode)) {
			navigate(-1);
		}
	}, [state?.processCode]);

	return (
		<Box>
			<DetailPageHeader title={'Create ' + (state?.processName ?? '')} />

			<Spin spinning={isSingleCaseLoading} style={{ maxHeight: '100%' }}>
				<MainCard>
					<Form form={form} layout="vertical" onFinish={onSubmitHandler} autoComplete="off" requiredMark={false}>
						<AntdValuePreview form={form} show={false} />

						<Row gutter={[16, 0]}>
							{/* <Col xs={24} md={18} lg={6} xl={8}>
								<NonDependantSelect
									label="Control Domain"
									name="DATA_controlDomain"
									code="DATA_controlDomain"
									displayNameCode="DATA_controlDomain_label"
								/>
							</Col>

							<Col xs={24} md={18} lg={6} xl={8}>
								<NonDependantSelect
									label="Control Sub-Domain"
									name="DATA_controlSubDomain"
									code="DATA_controlSubDomain"
									displayNameCode="DATA_controlSubDomain_label"
								/>
							</Col>

							<Col xs={24}>
								<Form.Item
									label="Control Questionnaire"
									name="controlQuestion"
									placeholder="Write here"
									rules={[
										{
											required: true,
											message: 'Field is required',
										},
									]}
								>
									<Input />
								</Form.Item>
							</Col> */}
							<Col xs={24} md={6} lg={6} xl={4}>
								<InputLabel label="Control Questionnaire" head={true} />
							</Col>
							<Col xs={24} md={18} lg={18} xl={20}>
								<Chip
									label={ControlQuestionnaire?.responseData?.controlQuestion}
									variant="outlined"
									sx={{
										width: '100%',
										justifyContent: 'start',
										fontWeight: 600,
										background: '#f2f2f2',
										borderColor: '#e2ebf7',
										marginBottom: '24px',
									}}
								/>
							</Col>
							<Col xs={24} md={6} lg={6} xl={4}>
								<InputLabel label="Control Domain" head={true} />
							</Col>
							<Col xs={24} md={18} lg={18} xl={8}>
								<NonDependantSelect
									name="DATA_controlDomain"
									code="DATA_controlDomain"
									displayNameCode="DATA_controlDomain_label"
									onChange={onDomainFilterHandler}
								/>
							</Col>
							<Col xs={24} md={6} lg={6} xl={4}>
								<InputLabel label="Control Sub-Domain" head={true} />
							</Col>
							<Col xs={24} md={18} lg={18} xl={8}>
								<NonDependantSelect
									name="DATA_controlSubDomain"
									code="DATA_controlSubDomain"
									displayNameCode="DATA_controlSubDomain_label"
									onChange={onDomainFilterHandler}
								/>
							</Col>
							<Col xs={24} md={4}>
								<InputLabel label="Control ID" head={true} />
							</Col>
							<Col xs={24} md={20}>
								<Form.Item name="controlIdLabel" noStyle />
								<Form.Item
									name="controlId"
									placeholder="Write here"
									rules={[
										{
											required: true,
											message: 'Field is required',
										},
									]}
								>
									<Select
										allowClear
										showSearch
										filterOption={filterChildOptionLabel}
										placeholder="Select from the list"
										onSelect={onSelectHandler}
										style={{ width: '100%', height: '32px', borderRadius: '4px' }}
									>
										{/* {options === null ? (
                                                                        <Skeleton variant="text" sx={{ fontSize: "1rem", marginX: 1 }} />
                                                                      ) : (
                                                                    )} */}
										{queryV3Data?.results?.map((value, index) => (
											<Select.Option key={index} value={value?.propertyCode}>
												{value?.displayName}
											</Select.Option>
										))}
									</Select>
								</Form.Item>
							</Col>
							<Col xs={24} md={6} lg={6} xl={4}>
								<InputLabel label="Assurer Type" head={true} />
							</Col>
							<Col xs={24} md={18} lg={6} xl={8}>
								<Form.Item
									name="assurerIdentityType"
									rules={[
										{
											required: true,
											message: 'Field is required',
										},
									]}
								>
									<Select
										showSearch
										allowClear
										style={{ width: '100%' }}
										filterOption={true}
										onChange={() => form.setFieldValue('assurerIdentityValue')}
										placeholder="Select from the list"
										optionFilterProp="children"
									>
										{assurerAndControlOwnerOptions?.map(({ key, value, label }) => (
											<Select.Option key={key} value={value}>
												{label}
											</Select.Option>
										))}
									</Select>
								</Form.Item>
							</Col>

							<Col xs={24} md={6} lg={6} xl={4}>
								<InputLabel label="Assurer Value" head={true} />
							</Col>
							<Col xs={24} md={18} lg={6} xl={8}>
								<Form.Item
									noStyle
									shouldUpdate={(previousValue, currentValue) =>
										previousValue?.assurerIdentityType !== currentValue?.assurerIdentityType
									}
								>
									{({ getFieldValue }) => (
										<DependantSelect
											name="assurerIdentityValue"
											displayNameCode="assurerIdentityLabel"
											code={getFieldValue('assurerIdentityType')}
											//   dependentCode="ownerIdentityType"
											isDependent={true}
											rules={[
												{
													required: true,
													message: 'Field is required',
												},
											]}
										/>
									)}
								</Form.Item>
							</Col>

							<Col xs={24} md={6} lg={6} xl={4}>
								<InputLabel label="Control Owner Type" head={true} />
							</Col>
							<Col xs={24} md={18} lg={6} xl={8}>
								<Form.Item
									name="ownerIdentityType"
									rules={[
										{
											required: true,
											message: 'Field is required',
										},
									]}
								>
									<Select
										showSearch
										allowClear
										style={{ width: '100%' }}
										filterOption={true}
										onChange={() => form.setFieldValue('ownerIdentityValue')}
										placeholder="Select from the list"
										optionFilterProp="children"
									>
										{assurerAndControlOwnerOptions?.map(({ key, value, label }) => (
											<Select.Option key={key} value={value}>
												{label}
											</Select.Option>
										))}
									</Select>
								</Form.Item>
							</Col>

							<Col xs={24} md={6} lg={6} xl={4}>
								<InputLabel label="Control Owner Value" head={true} />
							</Col>
							<Col xs={24} md={18} lg={6} xl={8}>
								<Form.Item
									noStyle
									shouldUpdate={(previousValue, currentValue) =>
										previousValue?.ownerIdentityType !== currentValue?.ownerIdentityType
									}
								>
									{({ getFieldValue }) => (
										<DependantSelect
											label=" "
											name="ownerIdentityValue"
											displayNameCode="ownerIdentityLabel"
											code={getFieldValue('ownerIdentityType')}
											//   dependentCode="ownerIdentityType"
											isDependent={true}
											rules={[
												{
													required: true,
													message: 'Field is required',
												},
											]}
										/>
									)}
								</Form.Item>
							</Col>

							<Col xs={24} md={6} lg={6} xl={4}>
								<InputLabel label="Reporting Frequency" head={true} />
							</Col>
							<Col xs={24} md={18} lg={6} xl={8}>
								<NonDependantSelect name="PROPERTY_frequency" code="PROPERTY_frequency" displayNameCode="PROPERTY_frequency_label" />
							</Col>

							<Col xs={24} md={6} lg={6} xl={4}>
								<InputLabel label="Reporting Due By" head={true} />
							</Col>
							<Col xs={24} md={18} lg={6} xl={8}>
								<Form.Item
									name="deadlineDaysCount"
									rules={[
										{
											required: true,
											message: 'Field is required',
										},
									]}
								>
									<InputNumber
										placeholder="n'th instant of the following month (5, 10, 15 etc.)"
										min={1}
										max={31}
										style={{ width: '100%' }}
									/>
								</Form.Item>
							</Col>

							<Col xs={24} md={6} lg={6} xl={4}>
								<InputLabel label="Expectation" head={true} />
							</Col>
							<Col xs={24} md={18} lg={6} xl={8}>
								<Form.Item
									name="expectation"
									placeholder="Write here"
									rules={[
										{
											required: true,
											message: 'Field is required',
										},
									]}
								>
									<Input />
								</Form.Item>
							</Col>

							<Col xs={24} md={6} lg={6} xl={4}>
								<InputLabel label="Escalation" head={true} />
							</Col>
							<Col xs={24} md={18} lg={6} xl={8}>
								<Form.Item
									name="escalation"
									placeholder="Write here"
									rules={[
										{
											required: true,
											message: 'Field is required',
										},
									]}
								>
									<Select
										showSearch
										allowClear
										style={{ width: '100%' }}
										filterOption={true}
										placeholder="Select form the list"
										optionFilterProp="children"
									>
										<Select.Option value="yes">Yes</Select.Option>
										<Select.Option value="no">No</Select.Option>
									</Select>
								</Form.Item>
							</Col>

							{/* <Col xs={24}>
                <Form.Item label="Control ID" name="controlId">
                  <Input disabled />
                </Form.Item>
              </Col>

              <Col xs={24}>
                <Form.Item label="Activation Status" name="activationStatus">
                  <Input disabled />
                </Form.Item>
              </Col> */}

							<Col xs={24} md={6} lg={6} xl={4}>
								<InputLabel label="Effective Date" head={true} />
							</Col>
							<Col xs={24} md={18} lg={6} xl={8}>
								<Form.Item name="effectiveDate">
									<DatePicker disabledDate={disablePastDates} style={{ width: '100%' }} />
								</Form.Item>
							</Col>

							<Col xs={24}>
								<Flex justify="end">
									<Button type="primary" htmlType="submit" style={{ backgroundColor: theme.palette.lynTheme.main }}>
										Submit
									</Button>
								</Flex>
							</Col>
						</Row>
					</Form>
				</MainCard>
			</Spin>

			{showModal && (
				<ComptrollerConfirmModal
					showModal={showModal}
					modalData={{
						head: state?.processName ?? '',
						label: 'Do you want to proceed?',
					}}
					setShowModal={setShowModal}
					handleSubmit={onModalOkHandler}
				/>
			)}
		</Box>
	);
}

export default Create;

export const DependantSelect = ({ name, displayNameCode, code, rules, isDependent = false, processCode }) => {
	const form = Form.useFormInstance();
	const userId = useSelector((state) => state.profile.profileData.userId);
	const companyCode = useSelector((state) => state.profile.profileData.creatorOrganizationId);
	const { state } = useLocation();

	const [options, setOptions] = useState(isDependent ? [] : null);

	const [GetLynFormData, { data: lynFormData }] = useGetLynFormDataMutation();
	const [GetLynFormProperty, { data: lynProperty }] = useGetLynFormPropertyMutation();

	const onSelectHandler = (value) => {
		if (displayNameCode) {
			const label = form.getFieldValue(value);
			form.setFieldValue(displayNameCode, label);
		}
	};

	useEffect(() => {
		if (code?.startsWith('PROPERTY_')) {
			GetLynFormProperty({
				type: 'FORM',
				fieldCode: state?.processCode || processCode,
				propertyCode: code,
				companyCode,
				processVersion: state?.processVersion,
				status: 'Active',
			});
		} else if (code?.startsWith('DATA_')) {
			const queryName = code.replace('DATA_', '');
			GetLynFormData({
				name: queryName,
				userId,
			});
		}
	}, [code, userId]);

	useEffect(() => {
		if (lynProperty?.lynProperties?.length > 0) {
			setOptions(lynProperty?.lynProperties);
			lynProperty?.lynProperties?.forEach((value) => {
				form.setFieldsValue({
					[value?.propertyValue]: value?.displayName,
				});
			});
		}

		if (lynFormData?.results?.length > 0) {
			setOptions(lynFormData?.results);
			lynFormData?.results?.forEach((value) => {
				form.setFieldsValue({
					[value?.propertyValue]: value?.displayName,
				});
			});
		}
	}, [lynProperty, lynFormData]);

	return (
		<>
			<Form.Item name={name} rules={rules}>
				{options === null ? (
					<Skeleton variant="text" sx={{ fontSize: '1rem', marginX: 1 }} />
				) : (
					<Select
						allowClear
						style={{ width: '100%' }}
						showSearch
						filterOption={filterChildOptionLabel}
						onSelect={onSelectHandler}
						placeholder="Select from the list"
						autoComplete="off"
					>
						{options?.map((value, index) => (
							<Select.Option key={index} value={value?.propertyValue}>
								{value?.displayName}
							</Select.Option>
						))}
					</Select>
				)}
			</Form.Item>
			<Form.Item noStyle name={displayNameCode} />
		</>
	);
};

export const NonDependantSelect = ({ label, name, code, displayNameCode, processCode, onChange = () => {} }) => {
	const form = Form.useFormInstance();
	const userId = useSelector((state) => state.profile.profileData.userId);
	const companyCode = useSelector((state) => state.profile.profileData.creatorOrganizationId);
	const { state } = useLocation();

	const [options, setOptions] = useState(null);

	const [GetLynFormData, { data: lynFormData }] = useGetLynFormDataMutation();
	const [GetLynFormProperty, { data: lynProperty }] = useGetLynFormPropertyMutation();

	const onSelectHandler = (value, obj) => {
		if (obj?.children) {
			form.setFieldValue(displayNameCode, obj?.children);
		}

		onChange();
	};

	useEffect(() => {
		if (code?.startsWith('PROPERTY_')) {
			GetLynFormProperty({
				type: 'FORM',
				fieldCode: state?.processCode || processCode,
				propertyCode: code,
				companyCode,
				processVersion: state?.processVersion,
				status: 'Active',
			});
		} else if (code?.startsWith('DATA_')) {
			const queryName = code.replace('DATA_', '');
			GetLynFormData({
				name: queryName,
				userId,
			});
		}
	}, [code, userId]);

	// Store options code & displayName in form.
	useEffect(() => {
		if (lynProperty?.lynProperties?.length > 0) {
			setOptions(lynProperty?.lynProperties);
			lynProperty?.lynProperties?.forEach((value) => {
				form.setFieldsValue({
					[value?.propertyValue]: value?.displayName,
				});
			});
		}

		if (lynFormData?.results?.length > 0) {
			setOptions(lynFormData?.results);
			lynFormData?.results?.forEach((value) => {
				form.setFieldsValue({
					[value?.propertyValue]: value?.displayName,
				});
			});
		}
	}, [lynProperty, lynFormData]);

	return (
		<>
			<Form.Item
				label={label}
				name={name}
				rules={[
					{
						required: true,
						message: 'Field is required',
					},
				]}
			>
				<Select
					allowClear
					showSearch
					style={{ width: '100%' }}
					onSelect={onSelectHandler}
					filterOption={filterChildOptionLabel}
					placeholder="Select from the list"
				>
					{options === null ? (
						<Skeleton variant="text" sx={{ fontSize: '1rem', marginX: 1 }} />
					) : (
						options?.map((value, index) => (
							<Select.Option key={index} value={value?.propertyValue}>
								{value?.displayName}
							</Select.Option>
						))
					)}
				</Select>
			</Form.Item>
			<Form.Item noStyle name={displayNameCode} />
		</>
	);
};
